module.exports = __webpack_public_path__ + "img/pro_six_5.0cd6fc28.jpg";